import {
  FetchAppVersionsAction,
  fetchAppVersionsDelegate,
} from './actions/FetchAppVersions';
import {
  FetchProjectAction,
  fetchProjectDelegate,
} from './actions/FetchProject';
import { FetchAppsAction, fetchAppsDelegate } from './actions/FetchApps';
import { ActionDelegate } from 'containers/Base/ActionDelegate';
import { SelectAppAction, selectAppDelegate } from './actions/SelectApp';
import {
  FetchAppConfigsAction,
  fetchAppConfigsDelegate,
} from './actions/FetchAppConfigs';
import {
  SelectAppVersionAction,
  selectAppVersionDelegate,
} from './actions/SelectAppVersion';
import { SelectEnvAction, selectEnvDelegate } from './actions/SelectEnv';
import {
  FetchServiceIntegrationsAction,
  fetchServiceIntegrationsDelegate,
} from './actions/FetchServiceIntegrations';
import { initialState, ProjectDetailState } from './state';
import {
  SelectProjectAction,
  selectProjectDelegate,
} from './actions/SelectProject';
import {
  UIAction,
  UIActionDelegate as uiActionDelegate,
} from './actions/uiActions';
import { selectAppConfigDelegate } from './actions/SelectAppConfig';
import { updateProjectDelegate } from './actions/UpdateProjectConfig';
import { updateAppConfigDelegate } from './actions/UpdateAppConfig';
import { AddAppVersionAction, addAppVersionDelegate } from './actions/AddAppVersion';

type ProjectDetailActions =
  | FetchProjectAction
  | FetchAppsAction
  | FetchAppVersionsAction
  | FetchAppConfigsAction
  | FetchServiceIntegrationsAction
  | SelectProjectAction
  | SelectAppAction
  | SelectAppVersionAction
  | SelectEnvAction
  | AddAppVersionAction
  | UIAction;

const delegates: {
  [key: string]: ActionDelegate<any, ProjectDetailState>;
} = {
  ...fetchProjectDelegate,
  ...fetchAppsDelegate,
  ...fetchAppVersionsDelegate,
  ...fetchAppConfigsDelegate,
  ...fetchServiceIntegrationsDelegate,
  ...selectProjectDelegate,
  ...updateProjectDelegate,
  ...selectAppDelegate,
  ...selectAppVersionDelegate,
  ...selectAppConfigDelegate,
  ...updateAppConfigDelegate,
  ...selectEnvDelegate,
  ...addAppVersionDelegate,
  ...uiActionDelegate,
};

export default function reduce(
  state: ProjectDetailState = initialState,
  action: ProjectDetailActions
): ProjectDetailState {
  const delegate = delegates[action.type];
  if (delegate) {
    return delegate(state, action);
  } else {
    return state;
  }
}
